import { useAtomValue } from 'jotai';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import { ArticleDetailUtil, EArticleClass } from 'shared/models';
import { ClickPosition } from '~/utils/click-position';
import { usePageActive } from '~/utils/active/use-page-active';
import { useCallback } from 'react';

export const useActiveToCurrentArticle = (): ((position: ClickPosition, id?: string) => void) => {
  const article = useAtomValue($CurrentArticle);

  const active = usePageActive();

  return useCallback((position, id) => {
    const articleAvailable = ArticleDetailUtil.isArticleAvailable(article);

    if (!articleAvailable) {
      return active({
        schemaOption: {
          pageType: 'feed',
          categoryId: 0,
        },
        ampExtra: {
          enter_position: position,
          enter_page_click_id: id || null,
        },
      });
    }

    const {
      articleClass,
      groupId,
      author: { userId },
    } = article;

    active({
      schemaOption: {
        pageType: articleClass === EArticleClass.VIDEO ? 'video' : 'article',
        groupId,
        authorId: userId,
      },
      ampExtra: {
        enter_position: position,
        enter_page_click_id: id || null,
      },
    });
  }, []);
};
